import { Box } from '@mui/material';
import React from 'react';
import { useSocketInstanceContext } from 'context/socketInstanceContext';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { addMessage, bonoBotState } from 'store/bonoBot/bonoBot.slice';
import ChatHintButton from './ChatHintButton';

const ChatHints = () => {
   const dispatch = useAppDispatch();
   const { isWaitingForResponse, sendMessageToServer } = useSocketInstanceContext();
   const { storedThreadId, messages } = useAppSelector(bonoBotState);

   const handleSuggestForMe = () => {
      if (!isWaitingForResponse) {
         // to AI
         sendMessageToServer('Suggest for me 3 random causes', storedThreadId);
         // to chat
         dispatch(addMessage({ role: 'user', text: 'Suggest for me 3 causes' }));
      }
   };

   const handlePopularCauses = () => {
      if (!isWaitingForResponse) {
         // to AI
         sendMessageToServer(
            'Suggest me the following causes: Stop Animal Suffering, Fight Climate Crisis, Disaster Relief.',
            storedThreadId
         );
         // to chat
         dispatch(addMessage({ role: 'user', text: 'Suggest me popular causes' }));
      }
   };

   const getButtons = () => {
      if (messages.length === 0) {
         return (
            <>
               <ChatHintButton
                  onClick={handleSuggestForMe}
                  text='Suggest for me'
                  icon={
                     <svg width={24} height={24} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
                        <path
                           d='M10.614 17.799a.946.946 0 0 1-1.744 0l-.877-2.01a7.74 7.74 0 0 0-3.94-3.992l-2.416-1.072c-.768-.341-.768-1.458 0-1.8l2.34-1.038a7.75 7.75 0 0 0 3.997-4.125l.89-2.142a.946.946 0 0 1 1.757 0l.89 2.142a7.75 7.75 0 0 0 3.997 4.125l2.34 1.039c.768.34.768 1.458 0 1.799l-2.415 1.072a7.74 7.74 0 0 0-3.941 3.991zM4.54 9.825c2.285 1.015 4.144 2.683 5.202 4.978 1.059-2.295 2.917-3.963 5.203-4.978C12.632 8.8 10.768 7.05 9.742 4.714 8.717 7.049 6.852 8.799 4.54 9.825M19.4 22.693l.247-.566a4.37 4.37 0 0 1 2.221-2.25l.76-.339a.53.53 0 0 0 0-.963l-.717-.319a4.37 4.37 0 0 1-2.253-2.326l-.254-.611a.507.507 0 0 0-.942 0l-.254.61a4.37 4.37 0 0 1-2.253 2.327l-.718.32a.53.53 0 0 0 0 .962l.76.338a4.37 4.37 0 0 1 2.222 2.251l.247.566c.18.414.754.414.934 0m-1.026-3.643.562-.559.55.559-.55.543z'
                           fill='#F55D66'
                        />
                     </svg>
                  }
               />
               <ChatHintButton
                  onClick={handlePopularCauses}
                  text='Popular causes'
                  icon={
                     <svg width={24} height={24} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
                        <mask
                           id='a'
                           style={{
                              maskType: 'alpha',
                           }}
                           maskUnits='userSpaceOnUse'
                           x={0}
                           y={0}
                           width={24}
                           height={24}
                        >
                           <path fill='#D9D9D9' d='M0 0h24v24H0z' />
                        </mask>
                        <g mask='url(#a)'>
                           <path
                              d='M6 20a.97.97 0 0 1-.713-.288A.97.97 0 0 1 5 19q0-.424.287-.712A.97.97 0 0 1 6 18h12q.424 0 .712.288.288.287.288.712 0 .424-.288.712A.97.97 0 0 1 18 20zm.7-3.5q-.725 0-1.288-.475a1.96 1.96 0 0 1-.687-1.2l-1-6.35a.6.6 0 0 0-.113.013.6.6 0 0 1-.112.012q-.625 0-1.062-.437A1.45 1.45 0 0 1 2 7q0-.625.438-1.062A1.45 1.45 0 0 1 3.5 5.5q.624 0 1.063.438Q5 6.374 5 7q0 .175-.037.325-.039.15-.088.275L8 9l3.125-4.275A1.54 1.54 0 0 1 10.5 3.5q0-.625.438-1.062A1.45 1.45 0 0 1 12 2q.624 0 1.063.438.437.436.437 1.062 0 .375-.175.7a1.54 1.54 0 0 1-.45.525L16 9l3.125-1.4a2 2 0 0 1-.087-.275A1.3 1.3 0 0 1 19 7q0-.625.438-1.062A1.45 1.45 0 0 1 20.5 5.5q.625 0 1.063.438Q22 6.374 22 7q0 .624-.437 1.063A1.45 1.45 0 0 1 20.5 8.5a.6.6 0 0 1-.113-.012.6.6 0 0 0-.112-.013l-1 6.35a1.96 1.96 0 0 1-.687 1.2 1.94 1.94 0 0 1-1.288.475zm0-2h10.6l.65-4.175-1.15.5a2 2 0 0 1-1.325.1 1.94 1.94 0 0 1-1.1-.75L12 6.9l-2.375 3.275a1.94 1.94 0 0 1-1.1.75q-.675.175-1.325-.1l-1.15-.5z'
                              fill='#F55D66'
                           />
                        </g>
                     </svg>
                  }
               />
            </>
         );
         // case 'select_cause':
         //    return (
         //       <ChatHintButton
         //          onClick={() => handleMoreSuggestions('causes')}
         //          text='More suggestions'
         //          icon={<DynamicGoogleIcon iconColor='#F55D66' iconName='add_circle' />}
         //       />
         //    );
         // case 'select_charity':
         //    return (
         //       <ChatHintButton
         //          onClick={() => handleMoreSuggestions('charities')}
         //          text='More suggestions'
         //          icon={<DynamicGoogleIcon iconColor='#F55D66' iconName='add_circle' />}
         //       />
         //    );
      }
      return null;
   };

   return (
      <Box sx={{ width: '100%', display: 'flex', flexDirection: 'row', columnGap: '4px', flexWrap: 'wrap' }}>
         {getButtons()}
         {/* <ChatHintButton text='Skip' icon={<DynamicGoogleIcon iconColor='#F55D66' iconName='arrow_forward' />} /> */}
      </Box>
   );
};

export default ChatHints;
